import Navbar from "./NavBar";
import Footer from "./Footer";
import CookiesCard from "../component/CookiesCard";
import { useEffect, useState } from "react";
export default function MainLayout({ children }) {
  const [scrolled, setScrolled] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const onScroll = () => {
      setScrolled(window.scrollY > 0); // Adjust scroll point here
    };

    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    const t = setTimeout(() => setLoading(false), 5000); // 5s branded loader
    return () => clearTimeout(t);
  }, []);
  return (
    <div>
      <Navbar />
      <main
        className={`mt-[80px] w-full  transition-all duration-500 ${
          scrolled ? "rounded-tl-[100px]" : ""
        }`}
        
      >
        <div className={`min-h-[calc(100vh-100px)] w-full px-8 md:px-[60px] bg-[#FFFFFF] dark:bg-[#0A1F35] bg-[radial-gradient(1200px_600px_at_10%_-20%,rgba(218,111,43,0.2),transparent),radial-gradient(800px_400px_at_90%_110%,rgba(255,255,255,0.08),transparent)] text-white/90`}> 
          <div className="anim-fadeIn anim-fadeUp">
            {children}
          </div>
        </div>
      </main>
      {loading && (
        <div className="ga-loader">
          <div className="glass-card p-6 rounded-2xl text-center">
            <div className="ga-pulse mx-auto" />
            <p className="mt-4 text-white/90">Preparing your sports experience…</p>
          </div>
        </div>
      )}
      <CookiesCard />
      <Footer />
      
    </div>
  );
}
